import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom"; 
import config from '../../config';

function ShareholdersList() {
    const [shareholders, setShareholders] = useState([]);
    const [menus, setmenus] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const fetchShareholders = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-shareholders`, { withCredentials: true });
            
            if(response.data){
                setShareholders(response.data);
            }

        } catch (err) {
            setError('Failed to fetch shareholders');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchShareholders();
    }, []);

    return (
        <>
            <div className="dashboard">
                <div className="container">
                    <h1 className="dash_title">Shareholders</h1>
                    <div className="main-section">
                        <div className="projects">
                            <div className="projects-inner">
                                <header className="projects-header">
                                    <div className="title">
                                        Total 
                                        <div className="count"> {shareholders.length } Shareholders</div>
                                    </div>
                                    <div className="project_search">
                                        {/* <form action="">
                                            <input type="text" name="search" placeholder="Search projects" />
                                            <button type="submit" className="btn">Search</button>
                                        </form> */}
                                    </div>
                                    <div className="add_project">
                                    <Link to="/admin/add-shareholder">Add Shareholder</Link>
                                    </div>
                                </header>
                                <table className="projects-table">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Description</th>
                                            <th>Led</th>
                                            <th>Space</th>
                                            <th className="text-right">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="4">Loading...</td>
                                            </tr>
                                        ) : error ? (
                                            <tr>
                                                <td colSpan="4">{error}</td>
                                            </tr>
                                        ) : (
                                            shareholders.map((shareholder, index) => ( 
                                                <tr key={shareholder._id}>
                                                    <td><p>{shareholder.title}</p></td>
                                                    <td><p>{shareholder.description}</p></td>
                                                    <td><p>{shareholder.led}</p></td>
                                                    <td><p>{shareholder.space}</p></td>
                                                    <td>
                                                        <Link to={`/admin/shareholder/${shareholder._id}`} className="view_detail">View Details</Link>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ShareholdersList;
